module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-132.f8df026e.jpg";